import { createSlice } from '@reduxjs/toolkit';
import LoanOfficersRepository from 'repositories/realEstateAgent/LoanOfficersRepository';
import { createRestSlice } from 'utils/RestSlice';

const restSlice = createRestSlice({
  resource: 'loanOfficer',
  pluralResource: 'loanOfficers',
  repository: LoanOfficersRepository,
  slices: ['loadLoanOfficers', 'loadMoreLoanOfficers'],
});

const initialState = {
  ...restSlice.initialState,
};

const realEstateAgentLoanOfficersSlice = createSlice({
  name: 'realEstateAgentLoanOfficersSlice',
  initialState,
  reducers: {
    ...restSlice.reducers,
  },
});

export default realEstateAgentLoanOfficersSlice;
export const realEstateAgentLoanOfficersReducer = realEstateAgentLoanOfficersSlice.reducer;
export const realEstateAgentLoanOfficersHooks = restSlice.hooks(
  realEstateAgentLoanOfficersSlice,
  'realEstateAgentLoanOfficersReducer',
);



// WEBPACK FOOTER //
// ./src/reducers/slices/realEstateAgent/loanOfficersSlice.js